export default "__VITE_ASSET__D6cEA2SU__"